import React, { useContext, useMemo, useState } from "react";
import PopoverMenu from "./PopoverMenu";
import { t } from "i18next";
import { hexToRgb } from "utils/colors.utils";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import Tooltip from "./Tooltip";
import { WalletIcon } from "../../icons/index.js";
import { scaleNumber, toFixedTrunc } from "utils/MathHelpers";

const HeaderWallet = ({ balance, status, isLoading, theme }) => {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);

  const { userScope, currencySymbol, globalConfig } = useContext(AuthContext);

  const enableWallet = useMemo(
    () => globalConfig?.find((e) => e.key === "enableWallet")?.value || "true",
    [globalConfig]
  );

  const options = useMemo(() => {
    const walletTransfer = userScope?.wallets?.transfer;
    const renderWalletPage = () => {
      navigate("/app/header/wallets");
    };

    const renderTransferCreditsPage = () => {
      navigate("/app/header/transfercredits");
    };
    let options = [];

    if (enableWallet === "true") {
      options.push({
        value: "_My_wallet",
        label: t("_My_wallet"),
        onClick: renderWalletPage,
      });
    }

    options.push({
      disabled: !walletTransfer,
      value: "_Transfer_Credits",
      label: t("_Transfer_Credits"),
      onClick: walletTransfer ? renderTransferCreditsPage : null,
    });

    return options;
  }, [userScope, enableWallet]);

  return (
    balance && (
      <PopoverMenu
        options={options}
        open={open}
        setOpen={setOpen}
        contentMinWidth={"150px"}
        className="px-6 py-3"
      >
        <div>
          <Tooltip
            disabled={open}
            content={currencySymbol + " " + toFixedTrunc(Math.abs(balance))}
          >
            <div
              className="relative  py-1 rounded-[8px] bg-opacity-[0.06] flex items-center cursor-pointer select-none"
              style={{
                backgroundColor: `rgba(${hexToRgb(theme.secondaryColor)}, 0.1)`,
              }}
            >
              <div className="ltr:ml-3 rtl:mr-3 py-1">
                <WalletIcon
                  className="w-6 h-5"
                  style={{ color: theme.secondaryColor }}
                />
              </div>

              <div className="flex relative   flex-col ml-2 text mx-4">
                {status === "success" && !isLoading && (
                  <h1
                    style={{ color: theme.secondaryColor }}
                    className=" font-bold opacity-100 text-sm"
                  >
                    {currencySymbol} {scaleNumber(balance)}
                  </h1>
                )}
              </div>
            </div>
          </Tooltip>
        </div>
      </PopoverMenu>
    )
  );
};

export default HeaderWallet;
